import { sendMessage } from "../../../config/utils/message"
import { CORE_API_AKADEMIK } from "../../key/api"

export async function viewAkses(nim) {
    try {
        const response = await CORE_API_AKADEMIK.get('validasi/aksesmahasiswa?nim=' + nim)
        return response
    }
    catch (err) {
        sendMessage(500)
    }
}
